const doubleChar = (s: string) => `${s}${s}`

type Triplet<T> = [T, T, T]
const parseRgbHex = (hexCode: string): Triplet<number> => {
  if (!hexCode.startsWith('#')) {
    throw new Error('Hex representation of RGB must begin with "#"')
  }
  const hex = hexCode.slice(1)
  const isShortHex = hex.length === 3
  if (isShortHex || hex.length === 6) {
    const rgb = [0, 1, 2].map((rgbIndex) =>
      parseInt(
        isShortHex
          ? doubleChar(hex[rgbIndex])
          : hex.substring(2 * rgbIndex, 2 * rgbIndex + 2),
        16,
      ),
    ) as Triplet<number>
    if (rgb.every((value) => Number.isInteger(value))) {
      return rgb
    }
  }
  throw new Error('Invalid hex representation')
}

export const getRgba = (rgb: string, alpha = 1.0) =>
  `rgba(${[...parseRgbHex(rgb), alpha.toFixed(2)].join(',')})`
